import { isPossiblePhoneNumber } from "libphonenumber-js";
import { matchIsValidTel } from "mui-tel-input";

// libphonenumber-js can lag behind newly activated NANP overlays. 679 is a
// valid US overlay for metro Detroit, but older metadata may classify it as
// possible rather than valid until all prefixes are published.
export const isValidPhoneNumber = (value: string) => {
  if (matchIsValidTel(value)) {
    return true;
  }

  const digits = value.replace(/\D/g, "");
  return digits.startsWith("1679") && isPossiblePhoneNumber(value);
};
